document.addEventListener('DOMContentLoaded', function () {
  var DELIVERY_CONFIG = {
    timezone: 'Asia/Kolkata',
    openingHour: 9,
    countdownStartHour: 17,
    sameDayCutoffHour: 19
  };

  var card = document.querySelector('[data-jb-same-day-delivery]');

  if (!card) return;

  var title = card.querySelector('[data-jb-same-day-title]');
  var text = card.querySelector('[data-jb-same-day-text]');
  var timerId;
  var lastRenderedState = '';

  function getCurrentISTTime() {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: DELIVERY_CONFIG.timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    var values = {};

    formatter.formatToParts(new Date()).forEach(function (part) {
      if (part.type !== 'literal') {
        values[part.type] = Number(part.value);
      }
    });

    return values;
  }

  function getRemainingSameDayTime(istTime) {
    var currentMinutes = istTime.hour * 60 + istTime.minute;
    var cutoffMinutes = DELIVERY_CONFIG.sameDayCutoffHour * 60;
    var remainingMinutes = cutoffMinutes - currentMinutes;

    if (remainingMinutes <= 0) return null;

    return {
      hours: Math.floor(remainingMinutes / 60),
      minutes: remainingMinutes % 60
    };
  }

  function getDeliveryState(istTime) {
    if (istTime.hour < DELIVERY_CONFIG.openingHour) {
      return 'before-opening';
    }

    if (istTime.hour < DELIVERY_CONFIG.countdownStartHour) {
      return 'available';
    }

    if (istTime.hour < DELIVERY_CONFIG.sameDayCutoffHour) {
      return 'countdown';
    }

    return 'closed';
  }

  function renderCountdown(state, istTime) {
    var remainingTime = getRemainingSameDayTime(istTime);
    var stateKey = state;

    if (state === 'countdown') {
      stateKey += '-' + remainingTime.hours + '-' + remainingTime.minutes;
    }

    if (stateKey === lastRenderedState) return;

    lastRenderedState = stateKey;
    card.classList.toggle('jb-same-day-delivery--closed', state === 'closed');
    text.hidden = false;

    if (state === 'before-opening') {
      title.textContent = '🚚 Same-day delivery starts at 9:00 AM.';
      text.hidden = true;
      return;
    }

    if (state === 'available') {
      title.textContent = '🚚 Same-day delivery available';
      text.textContent = 'Order today for delivery today.';
      return;
    }

    if (state === 'countdown') {
      title.textContent =
        '⏰ Order within ' +
        remainingTime.hours +
        'h ' +
        remainingTime.minutes +
        'm';

      text.textContent = 'for same-day delivery.';
      return;
    }

    title.textContent = '🌙 Same-day delivery is now closed.';
    text.textContent = 'Earliest available delivery is tomorrow.';
  }

  function getNextUpdateDelay(state, istTime) {
    var currentMinutes = istTime.hour * 60 + istTime.minute;
    var currentSeconds = istTime.second;

    if (state === 'before-opening') {
      return (
        ((DELIVERY_CONFIG.openingHour * 60 - currentMinutes) * 60 - currentSeconds) *
          1000 +
        50
      );
    }

    if (state === 'available') {
      return (
        ((DELIVERY_CONFIG.countdownStartHour * 60 - currentMinutes) * 60 -
          currentSeconds) *
          1000 +
        50
      );
    }

    if (state === 'countdown') {
      return (60 - currentSeconds) * 1000 + 50;
    }

    return (
      ((24 * 60 + DELIVERY_CONFIG.openingHour * 60 - currentMinutes) * 60 -
        currentSeconds) *
        1000 +
      50
    );
  }

  function updateCountdown() {
    var istTime = getCurrentISTTime();
    var state = getDeliveryState(istTime);

    renderCountdown(state, istTime);

    window.clearTimeout(timerId);

    timerId = window.setTimeout(function () {
      updateCountdown();
    }, getNextUpdateDelay(state, istTime));
  }

  updateCountdown();

  window.addEventListener(
    'pagehide',
    function () {
      window.clearTimeout(timerId);
    },
    { once: true }
  );
});